
//Dependencies
import React, { Component } from 'react';
import axios from 'axios';
import $ from 'jquery';

//material-ui
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import {ValidatorForm} from 'react-material-ui-form-validator';

// persistencia en redux
import {setInformacionObligatoria} from '../../../actions/actions';
import { store } from '../../../store/configure';
import {connect} from 'react-redux';

class InformacionObligatoria extends Component {
    constructor(props) {
        super(props);
        this.handleChange = this.handleChange.bind(this);
        this.informacionObligatoria = this.informacionObligatoria.bind(this);
    }

    isDataOk(){
        let { plazoFijoInformacionObligatoria } = this.props
    
        return plazoFijoInformacionObligatoria.sujetoObligado === "NO" &&
                plazoFijoInformacionObligatoria.politExp === "NO" &&
                plazoFijoInformacionObligatoria.ciudEst === "NO"
    }

    handleChange = event => {
        let name = event.target.name
        let value = event.target.value

        setInformacionObligatoria({
            fieldName:name,
            fieldValue:value
        })
    };

    informacionObligatoria = (event) => {
        event.preventDefault();
        $(".load").fadeIn(700);
        let data = {
            nombre: "lorem",
        }
        axios({
            method: 'post',
            timeout: 60 * 4 * 1000,
            data,
            url: localStorage.getItem('url') + '/api/plazoFijo/iniciar'
        },{withCredentials: true}).then((response) => {
            if (response.data.codigo === "SUCCESS") {
                this.props.history.push('/plazo-fijo/PF-info-personal');
            } else {
                this.props.history.push('/plazo-fijo/PF-solicitud-no-procesada');
            }
            $(".load").fadeOut(700);
        }).catch(error => {
            $(".load").fadeOut(700);
            this.props.history.push('/plazo-fijo/PF-solicitud-no-procesada');
        });
    }
    
    
    render() {
        const { classes, plazoFijoInformacionObligatoria } = this.props;

        return (
            <div className="io-container">
                <Grid container >
                  <ValidatorForm  autoComplete="off" ref="form-personales-basicos"
                        onSubmit={this.informacionObligatoria}>
                        <Grid item xs={12} >
                            <div className={classes.root}>
                                <FormControl
                                    component="fieldset">
                                    <FormLabel component="legend">¿Sos sujeto obligado?</FormLabel>
                                    <RadioGroup
                                        aria-label="Gender"
                                        name="sujetoObligado"
                                        className={classes.group}
                                        value={plazoFijoInformacionObligatoria.sujetoObligado}
                                        onChange={this.handleChange}
                                    >
                                        <FormControlLabel value="NO" control={<Radio color="primary" />} label="No" />
                                        <FormControlLabel value="SI" control={<Radio color="primary" />} label="Si" />
                                    </RadioGroup>
                                </FormControl>
                            </div>
                        </Grid>
                        <Grid item xs={12} >
                            <div className={classes.root}>
                                <FormControl
                                    component="fieldset">
                                    <FormLabel component="legend">¿Sos una persona expuesta políticamente?</FormLabel>
                                    <RadioGroup
                                        aria-label="Gender"
                                        name="politExp"
                                        className={classes.group}
                                        value={plazoFijoInformacionObligatoria.politExp}
                                        onChange={this.handleChange}>
                                        <FormControlLabel value="NO" control={<Radio color="primary" />} label="No" />
                                        <FormControlLabel value="SI" control={<Radio color="primary" />} label="Si" />
                                    </RadioGroup>
                                </FormControl>
                            </div>
                        </Grid>
                        <Grid item xs={12} >
                            <div className={classes.root}>
                                <FormControl component="fieldset">
                                    <FormLabel component="legend">¿Sos ciudadano estadounidense  y/o tenés residencia fiscal en otro país?</FormLabel>
                                    <RadioGroup
                                        aria-label="Gender"
                                        name="ciudEst"
                                        className={classes.group}
                                        value={plazoFijoInformacionObligatoria.ciudEst}
                                        onChange={this.handleChange}>
                                        <FormControlLabel value="NO" control={<Radio color="primary" />} label="No" />
                                        <FormControlLabel value="SI" control={<Radio color="primary" />} label="Si" />
                                    </RadioGroup>
                                </FormControl>
                            </div>
                        </Grid>
                    </ValidatorForm>
                </Grid>
            </div>
        );
    }
}

const styles = theme => ({
    root: {
        display: 'flex',
    },
    group: {
        margin: `${theme.spacing.unit}px 0`,
    },
});
const mapStateToProps = (state)=>{
  return ({
    plazoFijoInformacionObligatoria: state.plazoFijoInformacionObligatoria,
    estadoLocal: 'INFORMACION_OBLIGATORIA'
  });
}

export default connect(mapStateToProps, null, null, { withRef: true }) (withStyles(styles) (InformacionObligatoria));



// WEBPACK FOOTER //
// ./src/components/PlazoFijo/datosPersonales/InformacionObligatoria.js